import { reverseGeocode } from '@/utils/map/mapUtils';
import { STATE_ABBR_TO_NAME, stateFromReverseGeocode } from '@/utils/usStates';
import type { GuestMapHomeState } from '@/utils/guestHomeStateStorage';

/** Region labels aligned with HomeStatePage / legacy home-state picker. */
const STATE_REGION_BY_ABBR: Record<string, string> = {
  AL: 'South',
  AZ: 'Southwest',
  AR: 'South',
  CA: 'West',
  CO: 'Mountain',
  CT: 'Northeast',
  DE: 'Northeast',
  FL: 'South',
  GA: 'South',
  ID: 'Mountain',
  IL: 'Midwest',
  IN: 'Midwest',
  IA: 'Midwest',
  KS: 'Plains',
  KY: 'South',
  LA: 'South',
  ME: 'Northeast',
  MD: 'Northeast',
  MA: 'Northeast',
  MI: 'Midwest',
  MN: 'Midwest',
  MS: 'South',
  MO: 'Midwest',
  MT: 'Mountain',
  NE: 'Plains',
  NV: 'West',
  NH: 'Northeast',
  NJ: 'Northeast',
  NM: 'Southwest',
  NY: 'Northeast',
  NC: 'South',
  ND: 'Plains',
  OH: 'Midwest',
  OK: 'South',
  OR: 'West',
  PA: 'Northeast',
  RI: 'Northeast',
  SC: 'South',
  SD: 'Plains',
  TN: 'South',
  TX: 'South',
  UT: 'Mountain',
  VT: 'Northeast',
  VA: 'South',
  WA: 'West',
  WV: 'South',
  WI: 'Midwest',
  WY: 'Mountain',
};

/** Build guest/map home state from a USPS abbreviation (e.g. IP `regionCode`). */
export function homeStateFromAbbreviation(
  abbreviation: string,
): GuestMapHomeState | null {
  const abbr = abbreviation.trim().toUpperCase();
  const name = STATE_ABBR_TO_NAME[abbr];
  const region = STATE_REGION_BY_ABBR[abbr];
  if (!name || !region) return null;
  return { name, abbreviation: abbr, region };
}

function homeStateFromReverseGeocodeLabel(
  label: string | null | undefined,
): GuestMapHomeState | null {
  const abbr = stateFromReverseGeocode(label);
  if (!abbr) return null;
  return homeStateFromAbbreviation(abbr);
}

export async function deriveHomeStateFromCoordinates(
  longitude: number,
  latitude: number,
): Promise<GuestMapHomeState | null> {
  const label = await reverseGeocode(longitude, latitude);
  return homeStateFromReverseGeocodeLabel(label);
}
